import consumer from "./consumer"

consumer.subscriptions.create({ channel: "MessageChannel" }, {
  received(data) {
    notify(data);
  },

  connected() {
    console.log("Connected to Messages Channel");
  },

  disconnected() {
    console.log("Disconnected from Messages Channel");
  }
})

function notify(data) {
  console.log("MessageChannel", data)

  let unreadMessages = document.querySelector("#unreadMessages");

  if(data.unread > 0) {
    if(unreadMessages) {
      unreadMessages.classList.remove('d-none');
      unreadMessages.querySelector("a > span").innerHTML = data.unread;
    }

    if(document.title.indexOf('(') >= 0) {
      document.title = document.title.replace(/\(.+?\)/, '('+data.unread+')');
    } else {
      document.title = '('+data.unread+') '+document.title;
    }
  } else {
    if(unreadMessages) {
      unreadMessages.classList.add('d-none');
      unreadMessages.querySelector("a > span").innerHTML = '';
    }
    if(document.title.indexOf('(') >= 0) {
      document.title = document.title.replace(/\(.+?\)/, '');
    }
  }

  if(data.conversation && data.conversation != '') {
    var page = document.location.href.split('/');
    if(page[page.length-1] == 'messages')
    {
      updateConversations();
      updateMessages(data);
    } else if(page[page.length-1] == 'start') {
      updateStartPage();
    } else {

      const popover = new bootstrap.Popover('#unreadMessages', {
        content: `<div class="border-bottom mt-2 mb-2"><i class='far fa-comment'></i>&nbsp;<b>${data.sender}</div></b>${data.message}`,
        trigger: 'focus',
        html: true,
        placement: 'bottom'
      })
      popover.popover('show');

      setTimeout(function(){
        popover.popover('hide');
        popover.popover('dispose');
      }, 2000);
    }
  }
}

function updateConversations(data) {
  var url = window.location.protocol+'//'+window.location.host+'/'+window.location.pathname.split('/')[1]+'/messages/load';

  Rails.ajax({
    url: url,
    type: "get",
    data: "",
    success: function(data) {},
    error: function(data) {}
  });
}

function updateMessages(data) {
  let currentConversation = document.querySelector("#currentConversation");
  if(currentConversation.innerHTML == data.conversation) {
    var url = window.location.protocol+'//'+window.location.host+'/'+window.location.pathname.split('/')[1]+'/messages/reload?conversation='+data.conversation;

    Rails.ajax({
      url: url,
      type: "get",
      data: "",
      success: function(data) {},
      error: function(data) {}
    });
  }
}

function updateStartPage() {
  var url = window.location.protocol+'//'+window.location.host+'/'+window.location.pathname.split('/')[1]+'/start/refreshmessages';

  Rails.ajax({
    url: url,
    type: "get",
    data: "",
    success: function(data) {},
    error: function(data) {}
  });
}
